export default function () {
    // nothing to init
}
